import * as React from "react";
import axios from "axios";
import Button from "@material-ui/core/Button";
import { TextField, Typography } from "@material-ui/core";
import { DubitoSvc } from "../api";
//import cookie from 'react-cookie'

interface Props {}
export default class Login extends React.Component<Props> {
  state = {
    email: "",
    password: "",
    error: ""
  };

  render() {
    return (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          flexDirection: "column",
          justifyContent: "center",
          width: "100%",
          height: "50%"
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            flexDirection: "column",
            width: "100%",
            justifySelf: "center"
          }}
        >
          <div
            style={{
              marginLeft: 24,
              marginRight: 24
            }}
          >
            <Typography variant="headline">
              You are not authorized to see this page.
            </Typography>
            <Typography style={{ marginTop: 24 }} variant="subheading">
              If you think that is an error try clearing cache
            </Typography>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/auth/noAuth.tsx